module.exports = "/images/LON_portada.jpg?43a7ad30dab849482b739046c6b05b8b";